import type { TenantConfig } from "./types";

// librademo — 文档截图专用演示租户(2026-08,Jarod 使用手册需求)。
// 跑在旗舰 os.meganova.ai (.139) 旁,数据全部为虚构学生/班级/教师,
// 品牌走 LibraOS:logo 经 /brand/ 代理指向旗舰 nova-os 的 LibraOS
// 资产,school-ui 不自带任何品牌文件。
// 硬规则:此租户绝不导入任何真实学校数据 —— 它存在的意义就是让
// 手册截图不触碰客户隐私。
export const librademoTenant: TenantConfig = {
  slug: "librademo",
  displayName: "LibraOS Demo School",
  tagline: "LibraOS School",
  defaultLocale: "en",
  locales: ["en", "fr"],
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand/nova_os_icon_256.svg",
  },
};
